import { render, staticRenderFns } from "./new-template.vue?vue&type=template&id=15de42df"
import script from "./new-template.vue?vue&type=script&lang=js"
export * from "./new-template.vue?vue&type=script&lang=js"
import style0 from "./new-template.vue?vue&type=style&index=0&id=15de42df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports